import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import Layout from './components/layout/Layout';
import FriDaveLayout from './components/fridave/FriDaveLayout';
import ClubhouseLayout from './components/clubhouse/ClubhouseLayout';
import Notification from './components/common/Notification';
// import ConnectionStatus from './components/common/ConnectionStatus'; // Hidden - to be re-enabled with low connectivity features
import Players from './pages/Players';
import Members from './pages/Members';
import PlayerDetail from './pages/PlayerDetail';
import Courses from './pages/Courses';
import StablefordCalculator from './pages/StablefordCalculator';
import NewRound from './pages/NewRound';
import CreateEvent from './pages/CreateEvent';
import Events from './pages/Events';
import EventsHistory from './pages/EventsHistory';
import RoundSetup from './pages/RoundSetup';
import ActiveRound from './pages/ActiveRound';
import History from './pages/History';
import HistoryDetail from './pages/HistoryDetail';
import HistoryForm from './pages/HistoryForm';
import Leaderboard from './pages/Leaderboard';
import RoundResults from './pages/RoundResults';
import Scoring from './pages/Scoring';
import FriDaveLanding from './pages/fridave/FriDaveLanding';
import FriDaveRounds from './pages/fridave/FriDaveRounds';
import FriDaveCreateEvent from './pages/fridave/FriDaveCreateEvent';
import FriDaveScoring from './pages/fridave/FriDaveScoring';
import FriDaveStandings from './pages/fridave/FriDaveStandings';
import FriDaveStats from './pages/fridave/FriDaveStats';
import FriDavePlayerDetail from './pages/fridave/FriDavePlayerDetail';
import FriDaveSeriesPlayerDetail from './pages/fridave/FriDaveSeriesPlayerDetail';
import ClubhouseLanding from './pages/clubhouse/ClubhouseLanding';
import ClubhouseRounds from './pages/clubhouse/ClubhouseRounds';
import ClubhouseScoring from './pages/clubhouse/ClubhouseScoring';
import { ROUTES } from './utils/constants';

function App() {
  // Redirect fridave subdomain to /fridave
  if (window.location.hostname === 'fridave.tmlgolf.uk' &&
      !window.location.pathname.startsWith('/fridave')) {
    window.location.replace('/fridave');
    return null;
  }

  return (
    <Router>
      <AuthProvider>
        <WebSocketProvider>
          <Routes>
            {/* ── FriDave Super Series ── */}
            <Route path="/fridave" element={<FriDaveLayout><FriDaveLanding /></FriDaveLayout>} />
            <Route path="/fridave/scoring" element={<FriDaveLayout><FriDaveScoring /></FriDaveLayout>} />
            <Route path="/fridave/standings" element={<Navigate to="/fridave/stats" replace />} />
            <Route path="/fridave/stats" element={<FriDaveLayout><FriDaveStats /></FriDaveLayout>} />
            <Route path="/fridave/players/:playerId" element={<FriDaveLayout><FriDaveSeriesPlayerDetail /></FriDaveLayout>} />
            <Route path="/fridave/rounds/new" element={<FriDaveLayout><FriDaveCreateEvent /></FriDaveLayout>} />
            <Route path="/fridave/rounds/:roundId/setup" element={<FriDaveLayout><RoundSetup /></FriDaveLayout>} />
            <Route path="/fridave/rounds/:id/players/:playerId" element={<FriDaveLayout><FriDavePlayerDetail /></FriDaveLayout>} />
            <Route path="/fridave/rounds/:id" element={<FriDaveLayout><ActiveRound /></FriDaveLayout>} />
            <Route path="/fridave/rounds" element={<FriDaveLayout><FriDaveRounds /></FriDaveLayout>} />

            {/* ── The Clubhouse — guest ('open') events, reuses the shared round pages ── */}
            <Route path="/clubhouse" element={<ClubhouseLayout><ClubhouseLanding /></ClubhouseLayout>} />
            <Route path="/clubhouse/scoring" element={<ClubhouseLayout><ClubhouseScoring /></ClubhouseLayout>} />
            <Route path="/clubhouse/rounds" element={<ClubhouseLayout><ClubhouseRounds /></ClubhouseLayout>} />
            <Route path="/clubhouse/rounds/:roundId/setup" element={<ClubhouseLayout><RoundSetup /></ClubhouseLayout>} />
            <Route path="/clubhouse/rounds/:roundId/results" element={<ClubhouseLayout><RoundResults /></ClubhouseLayout>} />
            <Route path="/clubhouse/rounds/:roundId/players/:playerId" element={<ClubhouseLayout><PlayerDetail /></ClubhouseLayout>} />
            <Route path="/clubhouse/rounds/:id" element={<ClubhouseLayout><ActiveRound /></ClubhouseLayout>} />

            {/* ── TML (existing) ── */}
            <Route path="/*" element={
              <Layout>
                <Routes>
                  <Route path={ROUTES.HOME} element={<Navigate to={ROUTES.HISTORY} replace />} />
                  <Route path={ROUTES.PLAYERS} element={<Players />} />
                  <Route path={ROUTES.MEMBERS} element={<Members />} />
                  <Route path="/players/:playerId" element={<PlayerDetail />} />
                  <Route path="/rounds/:roundId/players/:playerId" element={<PlayerDetail />} />
                  <Route path="/rounds/:roundId/results" element={<RoundResults />} />
                  <Route path={ROUTES.COURSES} element={<Courses />} />
                  <Route path={ROUTES.CALCULATOR} element={<StablefordCalculator />} />
                  <Route path={ROUTES.NEW_ROUND} element={<NewRound />} />
                  <Route path={ROUTES.CREATE_EVENT} element={<CreateEvent />} />
                  <Route path={ROUTES.EVENTS} element={<Events />} />
                  <Route path="/events/history" element={<EventsHistory />} />
                  <Route path="/rounds/:roundId/setup" element={<RoundSetup />} />
                  <Route path="/rounds/:id" element={<ActiveRound />} />
                  <Route path={ROUTES.HISTORY} element={<History />} />
                  <Route path="/history/new" element={<HistoryForm />} />
                  <Route path="/history/edit/:id" element={<HistoryForm />} />
                  <Route path="/history/:year" element={<HistoryDetail />} />
                  <Route path={ROUTES.LEADERBOARD} element={<Leaderboard />} />
                  <Route path={ROUTES.SCORING} element={<Scoring />} />
                  <Route path="*" element={
                    <div className="text-center py-12">
                      <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                      <p className="text-xl text-gray-600">Page not found</p>
                    </div>
                  } />
                </Routes>
              </Layout>
            } />
          </Routes>
          <Notification />
          {/* <ConnectionStatus /> */}
        </WebSocketProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
